import Store from '@app/store';
import I18n from '@module/i18n';
import Router from '@module/router';

/*
  This could potentially be a place to;
  * Have Analytics, which will keep our components, actions etc. less polluted
  * Could be a place to manage UI based on state changes (thinking out loud)
  * ...maybe some more things?
*/

let originalDocumentTitle = null;

const updateDocumentTitle = (title) => {
  document.title = title;
};

const handleTransfer = () => {
  const { transfer, user, account, route, transferUpload } = Store.getState();

  // When the transfer has been cancelled
  if (transfer.state === 'init' && route.path === '/transfer/progress') {
    Router.navigateTo('/');
  }

  if (!user.loggedIn) {
    return;
  }
  if (!account.active_subscription) {
    return;
  }

  // Update document title when a transfer is in progress
  if (transfer.state === 'started') {
    const percentage = Math.max(
      0,
      Math.min(99, transferUpload.progress.percentage)
    );
    if (originalDocumentTitle === null) {
      originalDocumentTitle = document.title;
    }
    updateDocumentTitle(
      I18n.t('transfer.progress.document_title', { percentage })
    );
  } else {
    updateDocumentTitle(
      originalDocumentTitle !== null ? originalDocumentTitle : document.title
    );
    originalDocumentTitle = null;
  }
};

export const init = () => {
  Store.subscribe(handleTransfer);
};
